// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const LinkedIn: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44">
            <g fill="none" fillRule="evenodd">
                <circle cx="22" cy="22" r="21.5" stroke="#FFF" />
                <path
                    fill="currentColor"
                    fillRule="nonzero"
                    d="M16.7 33h-4.353V18.98H16.7V33Zm-2.179-15.933c-1.392 0-2.521-1.153-2.521-2.545 0-1.941 2.101-3.154 3.782-2.184a2.52 2.52 0 0 1 1.26 2.184c0 1.392-1.129 2.545-2.52 2.545ZM32.995 33h-4.344v-6.825c0-1.627-.033-3.713-2.264-3.713-2.263 0-2.61 1.768-2.61 3.596V33h-4.35V18.98h4.176v1.912h.061c.582-1.101 2.001-2.264 4.12-2.264 4.406 0 5.216 2.902 5.216 6.67V33h-.005Z"
                />
            </g>
        </svg>
    );
};

export default React.memo(LinkedIn);
